import { apiClient } from "./apiclient";

export const getBackdateConfig = (token) =>
  apiClient.get("/backdate-config", {
    headers: { Authorization: `Bearer ${token}` },
  });

export const updateBackdateConfig = (maxBackdateDays, token) =>
  apiClient.put("/backdate-config", { maxBackdateDays }, {
    headers: { Authorization: `Bearer ${token}` },
  });